import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: 'DateFor',
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      scheduleId: null,
      dateFor: null,
      editable: false,
      isLoading: false
    }
  },
  validations: {
    dateFor: { required },
    scheduleId: { required }
  },
  computed: {
    getTitle () {
      return this.$t('work-schedule.edit-date-for');
    },
    canEdit () {
      return !this.isLoading && this.editable;
    }
  },
  methods: {
    show (scheduleId, dateFor, editable) {
      this.editable = editable;
      this.dateFor = this.BasicHelper.cloneObject(dateFor);
      this.scheduleId = this.BasicHelper.cloneObject(scheduleId);
      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = {
          date_for: this.dateFor
        };
        this.ApiRequest.request('ezuro/schedule/edit-date-for/' + this.scheduleId, this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$emit('updateDateFor', { id: this.scheduleId, dateFor: reqData.date_for });
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
